import { render, staticRenderFns } from "./Psychiatry.vue?vue&type=template&id=de4604e8&"
import script from "./Psychiatry.vue?vue&type=script&lang=js&"
export * from "./Psychiatry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports